import(/* webpackMode: "eager" */ "/codebuild/output/src39902398/src/Camouflage-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/Banner/Banner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/BestBrand/BestBrand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/CollageSection/CollageSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/CustomLink/CustomNavLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/FeatureProduct/FeatureProduct.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/Location/Location.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/ShopByCategory/ShopbyCategory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/components/Slider/Slider.tsx");
